/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { authExternalProviderPost$Json } from '../fn/auth/auth-external-provider-post-json';
import { AuthExternalProviderPost$Json$Params } from '../fn/auth/auth-external-provider-post-json';
import { authExternalProviderPost$Plain } from '../fn/auth/auth-external-provider-post-plain';
import { AuthExternalProviderPost$Plain$Params } from '../fn/auth/auth-external-provider-post-plain';
import { authLoginPost$Json } from '../fn/auth/auth-login-post-json';
import { AuthLoginPost$Json$Params } from '../fn/auth/auth-login-post-json';
import { authLoginPost$Plain } from '../fn/auth/auth-login-post-plain';
import { AuthLoginPost$Plain$Params } from '../fn/auth/auth-login-post-plain';
import { authLogoutAllPost } from '../fn/auth/auth-logout-all-post';
import { AuthLogoutAllPost$Params } from '../fn/auth/auth-logout-all-post';
import { authLogoutPost } from '../fn/auth/auth-logout-post';
import { AuthLogoutPost$Params } from '../fn/auth/auth-logout-post';
import { authRefreshPost$Json } from '../fn/auth/auth-refresh-post-json';
import { AuthRefreshPost$Json$Params } from '../fn/auth/auth-refresh-post-json';
import { authRefreshPost$Plain } from '../fn/auth/auth-refresh-post-plain';
import { AuthRefreshPost$Plain$Params } from '../fn/auth/auth-refresh-post-plain';
import { AuthResponseDto } from '../models/auth-response-dto';
import { authSwitchOrganizationPost$Json } from '../fn/auth/auth-switch-organization-post-json';
import { AuthSwitchOrganizationPost$Json$Params } from '../fn/auth/auth-switch-organization-post-json';
import { authSwitchOrganizationPost$Plain } from '../fn/auth/auth-switch-organization-post-plain';
import { AuthSwitchOrganizationPost$Plain$Params } from '../fn/auth/auth-switch-organization-post-plain';

@Injectable({ providedIn: 'root' })
export class AuthApi extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `authLoginPost()` */
  static readonly AuthLoginPostPath = '/auth/login';

  /**
   * Sign in with email/password.
   *
   * Authenticates a user and returns JWT + user profile.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLoginPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authLoginPost$Plain$Response(params?: AuthLoginPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authLoginPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sign in with email/password.
   *
   * Authenticates a user and returns JWT + user profile.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLoginPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authLoginPost$Plain(params?: AuthLoginPost$Plain$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authLoginPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /**
   * Sign in with email/password.
   *
   * Authenticates a user and returns JWT + user profile.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLoginPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authLoginPost$Json$Response(params?: AuthLoginPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authLoginPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sign in with email/password.
   *
   * Authenticates a user and returns JWT + user profile.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLoginPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authLoginPost$Json(params?: AuthLoginPost$Json$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authLoginPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `authExternalProviderPost()` */
  static readonly AuthExternalProviderPostPath = '/auth/external/{provider}';

  /**
   * Handle external login.
   *
   * Completes an external login flow and returns tokens + user profile.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authExternalProviderPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalProviderPost$Plain$Response(params: AuthExternalProviderPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authExternalProviderPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Handle external login.
   *
   * Completes an external login flow and returns tokens + user profile.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authExternalProviderPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalProviderPost$Plain(params: AuthExternalProviderPost$Plain$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authExternalProviderPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /**
   * Handle external login.
   *
   * Completes an external login flow and returns tokens + user profile.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authExternalProviderPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalProviderPost$Json$Response(params: AuthExternalProviderPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authExternalProviderPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Handle external login.
   *
   * Completes an external login flow and returns tokens + user profile.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authExternalProviderPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authExternalProviderPost$Json(params: AuthExternalProviderPost$Json$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authExternalProviderPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `authSwitchOrganizationPost()` */
  static readonly AuthSwitchOrganizationPostPath = '/auth/switch-organization';

  /**
   * Switch current organization.
   *
   * Changes the active organization context for the current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSwitchOrganizationPost$Plain()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authSwitchOrganizationPost$Plain$Response(params?: AuthSwitchOrganizationPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authSwitchOrganizationPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Switch current organization.
   *
   * Changes the active organization context for the current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSwitchOrganizationPost$Plain$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authSwitchOrganizationPost$Plain(params?: AuthSwitchOrganizationPost$Plain$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authSwitchOrganizationPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /**
   * Switch current organization.
   *
   * Changes the active organization context for the current user.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authSwitchOrganizationPost$Json()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authSwitchOrganizationPost$Json$Response(params?: AuthSwitchOrganizationPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<AuthResponseDto>> {
    const obs = authSwitchOrganizationPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Switch current organization.
   *
   * Changes the active organization context for the current user.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authSwitchOrganizationPost$Json$Response()` instead.
   *
   * This method sends `application/*+json` and handles request body of type `application/*+json`.
   */
  authSwitchOrganizationPost$Json(params?: AuthSwitchOrganizationPost$Json$Params, context?: HttpContext): Observable<AuthResponseDto> {
    const resp = this.authSwitchOrganizationPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<AuthResponseDto>): AuthResponseDto => r.body)
    );
  }

  /** Path part for operation `authLogoutPost()` */
  static readonly AuthLogoutPostPath = '/auth/logout';

  /**
   * Logout current session.
   *
   * Revokes the current session (sid) so the current token becomes invalid.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLogoutPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutPost$Response(params?: AuthLogoutPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authLogoutPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Logout current session.
   *
   * Revokes the current session (sid) so the current token becomes invalid.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLogoutPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutPost(params?: AuthLogoutPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.authLogoutPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authLogoutAllPost()` */
  static readonly AuthLogoutAllPostPath = '/auth/logout-all';

  /**
   * Logout all sessions.
   *
   * Revokes all active sessions for current user in current organization.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authLogoutAllPost()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutAllPost$Response(params?: AuthLogoutAllPost$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = authLogoutAllPost(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Logout all sessions.
   *
   * Revokes all active sessions for current user in current organization.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authLogoutAllPost$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authLogoutAllPost(params?: AuthLogoutAllPost$Params, context?: HttpContext): Observable<void> {
    const resp = this.authLogoutAllPost$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `authRefreshPost()` */
  static readonly AuthRefreshPostPath = '/auth/refresh';

  /**
   * Refresh access token.
   *
   * Uses HttpOnly refresh cookie to issue a new 15-min JWT.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRefreshPost$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRefreshPost$Plain$Response(params?: AuthRefreshPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    const obs = authRefreshPost$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Refresh access token.
   *
   * Uses HttpOnly refresh cookie to issue a new 15-min JWT.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRefreshPost$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRefreshPost$Plain(params?: AuthRefreshPost$Plain$Params, context?: HttpContext): Observable<any> {
    const resp = this.authRefreshPost$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

  /**
   * Refresh access token.
   *
   * Uses HttpOnly refresh cookie to issue a new 15-min JWT.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `authRefreshPost$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRefreshPost$Json$Response(params?: AuthRefreshPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<any>> {
    const obs = authRefreshPost$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Refresh access token.
   *
   * Uses HttpOnly refresh cookie to issue a new 15-min JWT.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `authRefreshPost$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  authRefreshPost$Json(params?: AuthRefreshPost$Json$Params, context?: HttpContext): Observable<any> {
    const resp = this.authRefreshPost$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<any>): any => r.body)
    );
  }

}
